import React, { useEffect, useState } from 'react'
import GenericFormHeaderComponent from '../../../../genericComponents/forms/GenericFormHeaderComponent';
import GenericCustomButton from '../../../../genericComponents/GenericCustomButton';
import GenericSpinnerLoader from '../../../../loaders/GenericSpinnerLoader';
import Icons from '../../../../assets/icons';
import { useDispatch, useSelector } from 'react-redux';
import { dispatchHandler, getTokenData } from '../../../../helper/apiHelperFunctions';
import { v4 as uuidv4 } from 'uuid';
import { CircleCheck, Info, X } from 'lucide-react';
import LanguageTranslator from '../../../../locals/LanguageTranslator';
import dayjs from 'dayjs';
import { Tooltip } from 'antd';
import { getPermissionKey } from '../../../../helper/permissions';
import { parseJwt } from '../../../../helper/genericFunction';

let parseToken = parseJwt(sessionStorage.getItem('token')), hopscotchSchemaEntId = ["8534", "754"];


const MultipleAsnSubmissionModal = (props) => {

    const createMultipleAsnData = useSelector(state => state?.digivendStore?.createMultipleAsnData);

    let { draftedAsnData = [], getPayload, prevParams = {}, isSaveASNDatailEnable = false } = props || {};

    const dispatch = useDispatch();

    const [asnData, setAsnData] = useState(JSON.parse(JSON.stringify(draftedAsnData)));

    // const [loading, setLoading] = useState(false);

    // const [callApiFor, setCallApiFor] = useState(false);

    // const [errorData, setErrorData] = useState({});

    // const [apiCalled, setApiCalled] = useState({});

    // const [successAsn, setSuccessAsn] = useState({});

    // const tokenData = getTokenData(sessionStorage.getItem("token"));

    // useEffect(() => {

    //     if(callApiFor){

    //         if(asnData?.[callApiFor]){
    //             setLoading(callApiFor);

    //             if(errorData[callApiFor]){
    //                 let updatedErrorData = {...errorData};
    //                 delete updatedErrorData?.[callApiFor];
    //                 setErrorData(updatedErrorData);
    //             }

    //             let item = asnData?.[callApiFor];

    //             dispatchHandler(dispatch, "createMultipleAsnRequest",)
    //         }

    //         setCallApiFor(false);
    //     }

    // }, [callApiFor])

    useEffect(() => {
        if (createMultipleAsnData?.isSuccess) {
            props.closeModalNew();
        }
    }, [createMultipleAsnData])

    console.log("this is the asn modal drafted data", asnData)


    // Function : To submit the multiple asn
    const submitMultipleAsn = () => {
        // Don't call for the last submit
        // const deepClone = (obj) => JSON.parse(JSON.stringify(obj));
        let payload = [];
        // Object.keys(asnData || {})?.map(key => {
        //     let item = asnData?.[key];
        //     payload.push({
        //         ...getPayload({
        //             poDetails: deepClone(item.poDetails),
        //             formData: deepClone(item.formData),
        //             state: deepClone(item.state),
        //             boxes: deepClone(item.boxes),
        //             skuWiseBoxes: deepClone(item.skuWiseBoxes),
        //         }),
        //         requestId: `${props.uuId}-${key}`
        //     })
        // })

        Object.keys(asnData || {}).forEach(key => {
            const item = asnData[key];

            const clonedItem = structuredClone(item);  // Modern JS deep clone

            payload.push({
                ...getPayload({
                    poDetails: clonedItem.poDetails,
                    formData: clonedItem.formData,
                    state: clonedItem.state,
                    boxes: clonedItem.boxes,
                    skuWiseBoxes: clonedItem.skuWiseBoxes,
                }),
                requestId: `${props.uuId}-${key}`,
            });
        });
        if(isSaveASNDatailEnable) {
            props?.handleInputChange?.("storeASNData", payload);
        }
        else dispatchHandler(dispatch, "createMultipleAsnRequest", payload, getPermissionKey("purchase", "shipment", "create"))
    }

    const getTotalCount = (data) => {
        let totalCount = 0;
        let totalBoxes = 0;
        data?.boxes?.map((item, index) => {
            let noOfSKU = 0, perBoxQty = 0;
            Object.values(data?.skuWiseBoxes).forEach(value => {
                if (value[index] && value[index] !== null) {
                    noOfSKU++;
                    perBoxQty += Number(value[index])
                }
            });
            totalCount += perBoxQty * item.boxCount
            totalBoxes += +item.boxCount;
        })
        return { totalCount, totalBoxes };
    }

    

    return (
        <div className='text-fontBlack'>
            <GenericFormHeaderComponent
                // headerClassName={'border-b border-borderSlateGrey'}
                label={{
                    contentPrimary: "Confirm Submit",
                }}
                rowEndComponent={() => (
                    <div className='flex items-center gap-3'>
                        <GenericCustomButton type='default' label="Close" disabled={createMultipleAsnData?.isLoading} onClick={() => props.closeModalNew()} />
                        <GenericCustomButton type='primary' label="Confirm" disabled={createMultipleAsnData?.isLoading} onClick={() => submitMultipleAsn()} />
                    </div>
                )}
            />

            <div className='px-4 pb-4'>
                <div className='px-3 py-3 mb-3 flex items-start gap-3 bg-[#E7F1FF]'>
                    <span><Info size={22} color='#2B83FF' /></span>
                    <LanguageTranslator tag='p' className='mb-0 text-xs text-[#4D719C]'>Below are the draft ASN you have created. Once you Click confirm button, it will generate multiple ASNs simultaneously.</LanguageTranslator>
                </div>
                {/* Render the list for all the asn */}
                {Object.keys(asnData || {})?.length > 0 && <div className='max-h-[200px] overflow-auto'>
                    {
                        Object.keys(asnData || {})?.map(key => {

                            let totalRequestedQty = 0;
                            let numberOfAttachements = {};
                            asnData?.[key]?.poDetails?.map(item => {
                                totalRequestedQty += Number(item?.newRequestedQty);
                            })

                            if (asnData?.[key]?.formData?.invoiceUpload?.[0]?.filePath) {
                                numberOfAttachements["Invoice Upload"] = asnData?.[key]?.formData?.invoiceUpload?.length;
                            }
                            if (asnData?.[key]?.formData?.packingList?.[0]?.filePath) {
                                numberOfAttachements["Packing List"] = asnData?.[key]?.formData?.packingList?.length;
                            }
                            if (asnData?.[key]?.formData?.ppsDoc?.[0]?.filePath) {
                                numberOfAttachements["PPS Doc"] = asnData?.[key]?.formData?.ppsDoc?.length;
                            }
                            if (asnData?.[key]?.formData?.testReport?.[0]?.filePath) {
                                numberOfAttachements["Test Report"] = asnData?.[key]?.formData?.testReport?.length;
                            }

                            return (
                                <div>
                                    <div className='px-3 py-1.5 border border-borderSlateGrey flex items-center justify-between gap-4'>
                                        <LanguageTranslator tag="p" className='mb-0 text-[13px] font-medium'>{key}</LanguageTranslator>
                                        <div className='flex items-center gap-3'>
                                            <LanguageTranslator tag="p" className='mb-0 text-[13px] font-medium'><LanguageTranslator>Total Requested Qty</LanguageTranslator> : {totalRequestedQty}</LanguageTranslator>
                                        </div>
                                    </div>
                                    <div className='flex flex-wrap py-2'>
                                        {asnData?.[key]?.state?.boxCreation && asnData?.[key]?.boxes?.length && <div className='flex flex-col pr-2'>
                                            <LanguageTranslator tag="label" className='text-[11px] m-0 text-black font-medium'>Number Of Boxes</LanguageTranslator>
                                            <p className='text-[10px] text-[#67768e] m-0'>{getTotalCount(asnData?.[key])?.totalBoxes}</p>
                                        </div>}
                                        {asnData?.[key]?.formData?.shipmentRequestDate && <div className='flex flex-col pr-2'>
                                            <LanguageTranslator tag="label" className='text-[11px] m-0 text-black font-medium'>Expected Delivery Date</LanguageTranslator>
                                            <p className='text-[10px] text-[#67768e] m-0'>{dayjs(asnData?.[key]?.formData?.shipmentRequestDate || "")?.format(hopscotchSchemaEntId?.includes(parseToken?.schemaEntID) ? "DD-MM-YYYY" : "DD MMM YYYY")}</p>
                                        </div>}
                                        {asnData?.[key]?.formData?.invoiceAmount && <div className='flex flex-col pr-2'>
                                            <LanguageTranslator tag="label" className='text-[11px] m-0 text-black font-medium'>Invoice Amount</LanguageTranslator>
                                            <p className='text-[10px] text-[#67768e] m-0'>{asnData?.[key]?.formData?.invoiceAmount || ""}</p>
                                        </div>}
                                        {asnData?.[key]?.formData?.remarks && <div className='flex flex-col pr-2'>
                                            <LanguageTranslator tag="label" className='text-[11px] m-0 text-black font-medium'>Remarks</LanguageTranslator>
                                            <p className='text-[10px] text-[#67768e] m-0'>{asnData?.[key]?.formData?.remarks || ""}</p>
                                        </div>}
                                        {Object.keys(numberOfAttachements || {})?.length > 0 && <div className='flex flex-col pr-2'>
                                            <LanguageTranslator tag="label" className='text-[11px] m-0 text-black font-medium'>Attachment Details</LanguageTranslator>
                                            <LanguageTranslator tag="p" className='text-[10px] text-[#67768e] m-0 flex items-center'>{Object.keys(numberOfAttachements || {})?.length} Attachment{Object.keys(numberOfAttachements || {})?.length > 1 ? 's' : ''} Uploaded
                                                <Tooltip
                                                    title={
                                                        Object.keys(numberOfAttachements || {})?.map((key) => (
                                                            <LanguageTranslator tag="p" className='text-[11px] text-white m-0' key={key}>
                                                                {key}: {numberOfAttachements?.[key]} Document
                                                                {numberOfAttachements?.[key] > 1 ? 's' : ''} Uploaded
                                                            </LanguageTranslator>
                                                        ))
                                                    }
                                                    placement="top" // Adjust as needed (top, bottom, left, right)
                                                >
                                                    <Icons.InfoIcon className="cursor-pointer ml-1" />
                                                </Tooltip>
                                            </LanguageTranslator>
                                        </div>}
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>}

            </div>

        </div>
    )
}

export default MultipleAsnSubmissionModal